<template>
  <div v-if="formattedOptions.length > 1">
    <strong>Matrícula: </strong>
    <z-dropdown
      :items="formattedOptions"
      :value="currentBilling.id"
      link
      inline
      @input="selectBilling"
    />
  </div>
</template>

<script>
import ZDropdown from 'components/zilla/z-dropdown';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    ZDropdown,
  },
  data() {
    return {
      billingId: null,
    };
  },
  computed: {
    ...mapState([
      'currentBilling',
      'billings',
    ]),
    formattedOptions() {
      return this.billings.map((billing) => (
        { label: this.formattedLabelOptions(billing), value: billing.id }
      ));
    },
  },
  methods: {
    ...mapActions([
      'loadCurrentBill',
      'loadOverdueBills',
      'loadCurrentContract',
    ]),
    selectBilling(billingId) {
      const selectedBilling = this.billings.filter((billing) => billing.id === billingId)[0];
      this.$store.commit('setCurrentBilling', selectedBilling);
      this.$pageLoader.show('Carregando mensalidades');

      Promise.all([
        this.loadCurrentBill(),
        this.loadOverdueBills(),
        this.loadCurrentContract(),
      ]).catch((error) => error)
        .finally(() => this.$pageLoader.hide());
    },
    formattedLabelOptions(billing) {
      if (billing.dependent_name) {
        return `${billing.course_name} - ${billing.dependent_name}`;
      }
      return billing.course_name;
    },
  },
  mounted() {
    this.billingId = this.currentBilling.id;
  },
};
</script>
